import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { SelectionListInput, SelectionListOutput } from '@trackback/widgets';
import { combineLatest } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';
import { BaseFormControlWidgetComponent } from './base-form-control-widget.component';
import { ParsePipe } from '@app/pipes/parse.pipe';
import { ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { MatListOption, MatSelectionList } from '@angular/material/list';
import { coerceArray } from '@angular/cdk/coercion';

@Component({
  selector: 'tb-selection-list',
  template: `
    <mat-selection-list
      [formControl]="_formControl"
      [required]="input.required"
      [multiple]="input.multiple"
      (blur)="onBlur($event)"
      color="primary"
    >
      @for (option of parsedOptions$ | async; track $index) {
        <mat-list-option
          [value]="option.value"
          [disabled]="option.disabled"
          [togglePosition]="input.togglePosition ?? 'after'"
          >{{ option.label | parse: context | async }}</mat-list-option
        >
      }
    </mat-selection-list>
  `,
  styles: `
    tb-selection-list {
      display: inline-block;

      > mat-selection-list {
        width: 100%;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    ReactiveFormsModule,
    AsyncPipe,
    ParsePipe,
    MatSelectionList,
    MatListOption,
  ],
})
export default class SelectionListComponent extends BaseFormControlWidgetComponent<
  SelectionListInput,
  SelectionListOutput
> {
  public readonly parsedOptions$ = combineLatest([
    this.input$,
    this.context$,
  ]).pipe(
    switchMap(([input, context]) =>
      this._parser.parse(input && input.options, {
        context,
        log:
          !this._config || !this._config.PRODUCTION ? console.log : undefined,
      })
    ),
    shareReplay({
      bufferSize: 1,
      refCount: true,
    })
  );

  protected internalToExternal(next: any): any {
    if (!this.input.multiple && next && Array.isArray(next)) {
      return next[0];
    }
    return next;
  }

  protected externalToInternal(next: any): any {
    if (!this.input.multiple && next) {
      return coerceArray(next);
    }
    return next;
  }
}
